import Vue from 'vue';
import VueMaterial from 'vue-material';
import infiniteScroll from 'vue-infinite-scroll';

import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/fonts/slick.ttf';

import '../lib/common/css/dialog-globals.css';
import '../lib/common/css/globals.css';
import '../lib/common/css/new-globals.css';
import store from '~lib/common/store/webauth-store';
import analytics from '../lib/common/providers/analytics';
import featureAvailabilityService from '~lib/common/providers/featureAvailabilityService';

import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.config.performance = true;

Vue.use(VueMaterial);
Vue.use(infiniteScroll);

Vue.use(analytics, {
  router
});
Vue.use(featureAvailabilityService);
Vue.prototype.$eventHub = new Vue();

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
